import { APITransport } from '@client/transports/api';

export const TagsService = {
  async getAll(query = '*') {
    const response = await APITransport.get({
      path: '/rest/listofvalues/listadtags',
      query: {
        query
      }
    });

    return Array.isArray(response) ? response : [];
  },
  update({ msglink, tags }) {
    return APITransport.post({
      path: '/rest/user/execute/updatemsgtags',
      body: [
        {
          msglink,
          tags
        }
      ]
    });
  }
};
